export const LOGIN_SET = 'LOGIN_SET'
export const LOGIN_LOAD = 'LOGIN_LOAD'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILED = 'LOGIN_FAILED'
